import React from 'react'
import { Slot } from '@radix-ui/react-slot'

import classNames from 'classnames'

import styles from './IconButton.pcss'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	// Render the single child (e.g. a link) with the button styles
	asChild?: boolean
}

export const IconButton = React.forwardRef(function IconButton(
	{ asChild, className, ...props }: Props,
	ref: React.ForwardedRef<HTMLButtonElement>
): JSX.Element {
	const Component = asChild ? Slot : 'button'

	return (
		<Component
			className={classNames(styles.container, className)}
			ref={ref}
			{...props}
		/>
	)
})
